import Banner from 'components/Shared/Banner'
import React from 'react'

import './InfoBanner.scss'

export default function ({ learnMoreUrl }) {
  const learnMoreLink = learnMoreUrl ? (
    <a href={learnMoreUrl} target="_blank" rel="noopener noreferrer">
      Learn more
    </a>
  ) : null

  return (
    <div className="data-permissions-info-banner">
      <Banner gray icon="info">
        <p className="text">
          Add an extra layer of protection to sensitive data by controlling who
          can view or update that information. {learnMoreLink}
        </p>
      </Banner>
    </div>
  )
}
